import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poebillsettleApi = api
  .enhanceEndpoints({ addTagTypes: ['POEBillSettle'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOEBillSettles: builder.query<
        (po_ebillsettle & po_ebillsettledetails)[],
        string
      >({
        query: cid => `poebillsettle/${cid}`,
        providesTags: ['POEBillSettle']
      }),
      getPOEBillSettleByTable: builder.query<any[], any>({
        query: ({ cid, tbl }) => `poebillsettle/${cid}/${tbl}`,
        providesTags: ['POEBillSettle']
      }),
      getPOEBillSettleById: builder.query<po_ebillsettle, string>({
        query: id => `poebillsettle/byid/${id}`,
        providesTags: ['POEBillSettle']
      }),
      insertPOEBillSettle: builder.mutation({
        query: poebillsettle => ({
          url: `poebillsettle/`,
          method: 'POST',
          body: poebillsettle
        }),
        invalidatesTags: ['POEBillSettle']
      }),
      updatePOEBillSettle: builder.mutation({
        query: poebillsettle => ({
          url: `poebillsettle/`,
          method: 'PUT',
          body: poebillsettle
        }),
        invalidatesTags: ['POEBillSettle']
      }),
      deletePOEBillSettle: builder.mutation({
        query: poebillsettle => ({
          url: `poebillsettle/${poebillsettle.bs_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POEBillSettle']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOEBillSettlesQuery,
  useGetPOEBillSettleByTableQuery,
  useGetPOEBillSettleByIdQuery,
  useInsertPOEBillSettleMutation,
  useUpdatePOEBillSettleMutation,
  useDeletePOEBillSettleMutation
} = poebillsettleApi;

